import type { Prototype } from "../prototype-types";

export const markWidishPrototypes: Prototype[] = [
  {
    id: "mw-insider-hub-source-style",
    name: "Insider Hub (Source style)",
    path: "/mw/insider-hub-source-style",
    description:
      "Redesign of the Insider Shopping Hub modeled on the Faire Source Hub",
    owner: "Mark Widish",
    createdAt: "2026-05-08",
    lastUpdated: "2026-05-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e21160572e3fe39529f5cbc5a0dba05c0bc59f05238485da1f17cae0a187771e.png",
    creationTool: "claude-code",
  },
  {
    id: "mw-insider-minimum-milestone-in-cart",
    name: "Insider Minimum Milestone in Cart",
    path: "/mw/insider-minimum-milestone-in-cart",
    description:
      "Progress milestones in the cart toward unlocking Insider order minimum + free shipping",
    owner: "Mark Widish",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/a0ac84785eb6a870344975f978406aabb416abed1a7a1c30cdffd75147c25894.png",
    creationTool: "claude-code",
  },
];
